<template lang="pug">
#usuarios
    BaseHeader(
        :titulo='$t("mensagens.usuarios.titulo")',
        icon='el-icon-plus',
        :btnTexto='$t("mensagens.usuarios.cadastro")',
        :exibeBotao='true',
        @btnHeaderClicado='alterarMostrarModalCadastrarUsuario',
        :botoesSecundarios='hasRoleFeatureRevendaSucursalesAr ? botoesSecundarios : []',
        @botaoSecundarioHeaderClicado='abrirModalCadastrarSucursal'
    )

    .view-container-base-header
        .usuarios__barra-pesquisa
            i.el-icon-search
            input.lista-usuarios__barra-pesquisa__input(
                v-model='pagina.filter',
                type='text',
                :placeholder='$t("mensagens.usuarios.pesquisaInteligente")',
                autocomplete='off',
                @keyup.enter='onChangeSearchInput'
            )

        .usuarios__tabs-container
            el-tabs(
                v-model='activeTab',
                type='border-card',
                @tab-click='onTabClick'
            )
                el-tab-pane(
                    :label='$t("mensagens.usuarios.titulo")',
                    name='usuarios'
                )
                    TabelaUsuarios(
                        :usuarios='usuarios',
                        :totalUsuarios='totalUsuarios',
                        :pagina='pagina',
                        @ordenar='ordenar',
                        @abrirModalEditarUsuario='abrirModalEditarUsuario',
                        @reenviarEmail='reenviarEmail',
                        @acaoAlterarStatus='acaoAlterarStatus',
                        @changePage='onPageChangeAtivos'
                    )

                el-tab-pane(
                    v-if='hasRoleFeatureRevendaSucursalesAr',
                    label='Sucursales',
                    name='sucursal'
                )
                    TabelaSucursales(
                        :sucursales='sucursales',
                        :totalSucursales='totalSucursales',
                        :pagina='paginaSucursal',
                        @ordenar='ordenarSucursal',
                        @abrirModalEditarSucursal='abrirModalEditarSucursal',
                        @refetchSucursales='getSucursales'
                    )

    el-dialog.modal-cadastrar-usuario(
        :title='$t("mensagens.usuarios.cadastro")',
        :visible.sync='mostrarModalCadastrarUsuario',
        width='500px',
        :before-close='alterarMostrarModalCadastrarUsuario',
        :close-on-click-modal='false'
    )
        el-form(:model='novoUsuario')
            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.tabela.nome') }}
                    span.erro(v-if='$v.novoUsuario.nome.$invalid') *
                el-input(v-model='novoUsuario.nome')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.tabela.email.label') }}
                    span.erro(v-if='$v.novoUsuario.email.$invalid') *
                el-input(v-model='novoUsuario.email')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.empresa') }}
                    span.erro(v-if='$v.novoUsuario.idEmpresa.$invalid') *
                el-select(
                    v-model='novoUsuario.idEmpresa',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.buscaPorNome")',
                    filterable,
                    remote,
                    reserve-keyword,
                    :remote-method='remoteMethod'
                )
                    el-option(
                        v-for='empresa in empresas',
                        :key='"empresa" + empresa.id',
                        :label='empresa.name',
                        :value='empresa.id'
                    )

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.modalUsuario.perfil') }}
                el-select(
                    v-model='roleSelecionada',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
                    value-key='id',
                    clearable
                )
                    el-option(
                        v-for='role in rolesOperacao',
                        :key='"role" + role.id',
                        :label='getRoleTraduzido(role?.description)',
                        :value='role'
                    )

            el-form-item(v-if='deveExibirCampo()')
                .label(slot='label')
                    span {{ $t('mensagens.comuns.tipo') }}
                el-select(
                    v-model='novoUsuario.perfil',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
                    clearable,
                    @change='getUserNameById'
                )
                    el-option(
                        v-for='gerentes in gerente',
                        :key='gerentes.id',
                        :label='gerentes.nome',
                        :value='gerentes.id'
                    )

            el-form-item(v-if='deveExibirCampo()')
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.pessoaEstruturaComercial') }}
                el-select(
                    v-model='novoUsuarioGestor.idPessoa',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
                    clearable
                )
                    el-option(
                        v-for='usuarioRoles in usuarioRole',
                        :key='usuarioRoles.id',
                        :label='usuarioRoles.idPessoa.nome',
                        :value='usuarioRoles.idPessoa.id'
                    )

            el-form-item(v-if='deveExibirCampoAssistente()')
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.assistenteGestor') }}
                el-select(
                    v-model='novoUsuario.perfil',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
                    clearable,
                    @change='getUserNameById'
                )
                    el-option(
                        v-for='gerentes in gerente',
                        :key='gerentes.id',
                        :label='gerentes.nome',
                        :value='gerentes.id'
                    )

            el-form-item(v-if='deveExibirCampoAssistente()')
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.pessoaEstruturaComercial') }}
                el-select(
                    v-model='novoUsuarioGestor.idPessoa',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
                    clearable
                )
                    el-option(
                        v-for='usuariosRole in usuarioRole',
                        :key='usuariosRole.id',
                        :label='usuariosRole.idPessoa.nome',
                        :value='usuariosRole.idPessoa.id'
                    )
        footer(slot='footer')
            el-button(
                size='mini',
                @click='alterarMostrarModalCadastrarUsuario'
            ) {{ $t('mensagens.comuns.cancelar') }}
            el-button(
                :disabled='$v.novoUsuario.$invalid || $v.roleSelecionada.$invalid || (this.roleSelecionada.description !== "Administrador" && this.roleSelecionada.description !== "Regular" && $v.novoUsuarioGestor.$invalid)',
                size='mini',
                type='primary',
                @click='cadastrarUsuario'
            ) {{ $t('mensagens.comuns.cadastrar') }}

    el-dialog.modal-editar-usuario(
        :title='$t("mensagens.usuarios.editarUsuario.editar")',
        :visible.sync='mostrarModalEditarUsuario',
        width='500px',
        :before-close='fecharModalEditarUsuario',
        :close-on-click-modal='false'
    )
        el-form(:model='editarUsuario')
            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.tabela.nome') }}
                    span.erro(v-if='$v.editarUsuario.nome.$invalid') *
                el-input(v-model='editarUsuario.nome')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.tabela.email.label') }}
                    span.erro(v-if='$v.editarUsuario.email.$invalid') *
                el-input(v-model='editarUsuario.email')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.empresa') }}
                    span.erro(v-if='$v.editarUsuario.idEmpresa.$invalid') *
                el-select(
                    v-model='editarUsuario.idEmpresa',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.buscaPorNome")',
                    filterable,
                    remote,
                    reserve-keyword,
                    :remote-method='remoteMethod'
                )
                    el-option(
                        v-for='empresa in empresas',
                        :key='"empresa" + empresa.id',
                        :label='empresa.name',
                        :value='empresa.id'
                    )

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.modalUsuario.perfil') }}
                    span.erro(v-if='$v.editarUsuario.idRole.$invalid') *
                el-select(
                    v-model='roleSelecionada',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
                    value-key='id',
                    clearable,
                    @change='limpaPefilPessoa'
                )
                    el-option(
                        v-for='role in rolesOperacao',
                        :key='role.id',
                        :label='getRoleTraduzido(role?.description)',
                        :value='role'
                    )

            el-form-item(v-if='deveExibirCampoEditar()')
                .label(slot='label')
                    span {{ $t('mensagens.comuns.tipo') }}
                el-select(
                    v-model='editarUsuario.idPerfil',
                    placeholder='Selecione',
                    clearable,
                    @change='getUserNameById'
                )
                    el-option(
                        v-for='gerentes in gerente',
                        :key='gerentes.id',
                        :label='gerentes.nome',
                        :value='gerentes.id'
                    )

            el-form-item(v-if='deveExibirCampoEditar()')
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.pessoaEstruturaComercial') }}
                    span.erro(v-if='$v.editarUsuario.idPessoa') *
                el-select(
                    v-model='editarUsuario.idPessoa',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
                    clearable
                )
                    el-option(
                        v-for='usuarioRoles in usuarioRole',
                        :key='usuarioRoles.id',
                        :label='usuarioRoles.idPessoa.nome',
                        :value='usuarioRoles.idPessoa.id'
                    )

            el-form-item(v-if='deveExibirCampoEditarAssistente()')
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.assistenteGestor') }}
                el-select(
                    v-model='editarUsuario.idPerfil',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
                    clearable,
                    @change='getUserNameById'
                )
                    el-option(
                        v-for='gerentes in gerente',
                        :key='gerentes.id',
                        :label='gerentes.nome',
                        :value='gerentes.id'
                    )

            el-form-item(v-if='deveExibirCampoEditarAssistente()')
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.pessoaEstruturaComercial') }}
                el-select(
                    v-model='editarUsuario.idPessoa',
                    :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
                    clearable
                )
                    el-option(
                        v-for='usuariosRole in usuarioRole',
                        :key='usuariosRole.id',
                        :label='usuariosRole.idPessoa.nome',
                        :value='usuariosRole.idPessoa.id'
                    )

        footer(slot='footer')
            el-button(size='mini', @click='fecharModalEditarUsuario') {{ $t('mensagens.comuns.cancelar') }}
            el-button(
                :disabled='$v.editarUsuario.$invalid || $v.roleSelecionada.$invalid',
                size='mini',
                type='primary',
                @click='enviarUsuarioEditado'
            ) {{ $t('mensagens.comuns.editar') }}

    SucursaleModal(
        :visible.sync='mostrarModalCadastrarSucursal',
        @fechar='fecharModalCadastrarSucursal',
        @listaSucursais='getSucursales'
    )

    SucursaleEditarModal(
        :visible.sync='mostrarModalEditarSucursal',
        :sucursal='sucursal',
        @fechar='fecharModalEditarSucursal',
        @listaSucursais='getSucursales'
    )

    el-dialog.modal-altera-status(
        :visible.sync='mostrarModalAlterarStatus',
        width='500px',
        :before-close='alterarModalAlterarStatus'
    )
        h2 {{ $t('mensagens.usuarios.editarUsuario.textoAlteracao1') }} {{ alterarStatusUsuario.status ? $t('mensagens.usuarios.editarUsuario.textoAlteracaoDesativar') : $t('mensagens.usuarios.editarUsuario.textoAlteracaoAtivar') }} {{ $t('mensagens.usuarios.editarUsuario.textoAlteracao2') }} {{ alterarStatusUsuario.nome.trim() + '?' }}
        footer(slot='footer')
            el-button(size='mini', @click='alterarModalAlterarStatus') {{ $t('mensagens.comuns.cancelar') }}
            el-button(size='mini', type='primary', @click='alterarStatus') {{ alterarStatusUsuario.status ? $t('mensagens.usuarios.editarUsuario.botaoDesabilitar') : $t('mensagens.usuarios.editarUsuario.botaoHabilitar') }}
</template>

<script>
import { mapGetters } from 'vuex';
import BaseHeader from '@/components/BaseHeader';
import UsuarioService from '@/services/UsuarioService';
import SucursaleService from '@/services/SucursaleService';
import { required, email } from 'vuelidate/lib/validators';
import PessoaService from '@/services/PessoaService';
import PerfilPessoaService from '@/services/PerfilPessoaService';
import SucursaleModal from '@/components/usuario/SucursaleModal.vue';
import SucursaleEditarModal from '@/components/usuario/SucursaleEditarModal.vue';
import TabelaUsuarios from '@/components/usuario/TabelaUsuarios.vue';
import TabelaSucursales from '@/components/usuario/TabelaSucursales.vue';

export default {
    name: 'Usuarios',
    components: {
        BaseHeader,
        SucursaleModal,
        SucursaleEditarModal,
        TabelaUsuarios,
        TabelaSucursales
    },
    data() {
        return {
            usuarios: null,
            empresas: [],
            botoesSecundarios: [
                {
                    id: 1,
                    nome: this.$t('mensagens.usuarios.cadastroSucursales'),
                    icone: 'el-icon-circle-plus'
                }
            ],
            rolesOperacao: [],
            totalUsuarios: 0,
            roleSelecionada: '',
            usuarioRole: '',
            novoUsuarioGestor: {
                idPessoa: ''
            },
            activeTab: 'usuarios',
            sucursal: null,
            sucursales: null,
            totalSucursales: 0,
            ordemSucursal: null,
            paginaSucursal: {
                page: 1
            },
            perfis: [],
            pagina: {
                page: 1,
                filter: ''
            },

            mostrarModalCadastrarUsuario: false,
            novoUsuario: {
                nome: '',
                email: '',
                administrador: false,
                idEmpresa: '',
                idRole: ''
            },

            mostrarModalEditarUsuario: false,
            editarUsuario: {
                id: '',
                nome: '',
                email: '',
                administrador: false,
                idEmpresa: '',
                idRole: '',
                idTipo: ''
            },

            mostrarModalAlterarStatus: false,
            alterarStatusUsuario: {
                nome: '',
                status: false
            },

            mostrarModalCadastrarSucursal: false,
            mostrarModalEditarSucursal: false,

            ordem: null
        };
    },

    validations() {
        if (
            this.roleSelecionada.description === 'Gestor' ||
            this.roleSelecionada.description === 'Assistente'
        ) {
            return {
                novoUsuario: {
                    nome: { required },
                    email: { required, email },
                    idEmpresa: { required }
                },
                novoUsuarioGestor: {
                    idPessoa: { required }
                },
                editarUsuario: {
                    nome: { required },
                    email: { required, email },
                    idEmpresa: { required },
                    idRole: { required },
                    idPerfil: { required },
                    idPessoa: { required }
                },
                roleSelecionada: {
                    id: { required }
                }
            };
        } else {
            return {
                novoUsuario: {
                    nome: { required },
                    email: { required, email },
                    idEmpresa: { required }
                },
                editarUsuario: {
                    nome: { required },
                    email: { required, email },
                    idEmpresa: { required },
                    idRole: { required }
                },
                roleSelecionada: {
                    id: { required }
                }
            };
        }
    },

    computed: {
        ...mapGetters(['usuarioLogado']),

        hasRoleFeatureRevendaSucursalesAr() {
            return this.usuarioLogado.authorities.some(
                role => role.authority === 'ROLE_FEATURE_REVENDA_SUCURSALES_AR'
            );
        }
    },

    created() {
        this.getUsuarios();
        this.buscarPerfis();
        if (this.usuarioLogado.isBunge) {
            this.buscarPessoa();
            this.buscarPerfilPessoa();
        }
    },

    watch: {
        'novoUsuario.email': function () {
            this.novoUsuario.email = this.novoUsuario.email.trim();
        }
    },

    methods: {
        getUsuarios() {
            UsuarioService.getAll({
                page: this.pagina.page - 1,
                filter: this.pagina.filter.replaceAll('.', '').replace('-', ''),
                order: this.ordem
            })
                .then(({ data }) => {
                    this.usuarios = data.users;
                    this.totalUsuarios = data.totalUsers;
                    const gestorUsuario = this.usuarios.find(usuario => {
                        if (usuario.role !== null) {
                            return (
                                usuario.role.name === 'GESTOR' &&
                                usuario.idPerfil
                            );
                        }
                    });

                    if (gestorUsuario) {
                        this.editarUsuario.idPerfil = gestorUsuario.idPerfil;
                        this.perfis = this.editarUsuario.idPerfil;
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },
        getSucursales() {
            SucursaleService.listagemPaginada({
                page: this.paginaSucursal.page - 1,
                filter: this.pagina.filter,
                order: this.ordemSucursal
            })
                .then(({ data }) => {
                    this.sucursales = data.sucursais;
                    this.totalSucursales = data.paginacao.total;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        abrirModalCadastrarSucursal() {
            this.mostrarModalCadastrarSucursal = true;
        },

        abrirModalEditarSucursal(sucursal) {
            this.sucursal = sucursal;
            this.mostrarModalEditarSucursal = true;
        },

        onTabClick(tab) {
            this.activeTab = tab.name;

            // Buscar dados específicos para cada tab
            if (tab.name === 'usuarios' && this.usuarios === null) {
                this.getUsuarios();
            } else if (tab.name === 'sucursal' && this.sucursales === null) {
                this.getSucursales();
            }
        },

        onPageChangeAtivos(page) {
            this.pagina.page = page;
            this.getUsuarios();
        },

        onPageChangeSucursal(page) {
            this.paginaSucursal.page = page;
            this.getSucursales();
        },

        ordenarSucursal({ order }) {
            if (order === null) {
                this.ordemSucursal = null;
                return;
            }

            this.ordemSucursal = order === 'ascending' ? 'ASC' : 'DESC';
            this.getSucursales();
        },

        onChangeSearchInputSucursal() {
            this.getSucursales();
        },

        fecharModalCadastrarSucursal() {
            this.mostrarModalCadastrarSucursal = false;
        },

        fecharModalEditarSucursal() {
            this.mostrarModalEditarSucursal = false;
        },

        buscarEmpresasSubEmpresas(query) {
            UsuarioService.buscarEmpresasSubEmpresas(this.getFiltros(query))
                .then(({ data }) => {
                    this.empresas = data;

                    const bungeEmpresa = this.empresas.find(
                        empresa =>
                            empresa.attributes.hasOwnProperty('client') &&
                            empresa.attributes.client[0] === 'client-lyra-bunge'
                    );

                    if (bungeEmpresa) {
                        return this.empresas;
                    } else {
                        const gestorIndex = this.rolesOperacao.findIndex(
                            role => role.name === 'GESTOR'
                        );
                        const AssistenteIndex = this.rolesOperacao.findIndex(
                            role => role.name === 'ASSISTENTE'
                        );
                        if (gestorIndex !== -1 && AssistenteIndex !== -1) {
                            this.rolesOperacao.splice(gestorIndex, 1);
                            this.rolesOperacao.splice(AssistenteIndex, 1);
                        }
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        deveExibirCampo() {
            return this.roleSelecionada?.name === 'GESTOR';
        },

        deveExibirCampoEditar() {
            return this.roleSelecionada?.name === 'GESTOR';
        },

        deveExibirCampoAssistente() {
            return this.roleSelecionada?.name === 'ASSISTENTE';
        },

        deveExibirCampoEditarAssistente() {
            return this.roleSelecionada?.name === 'ASSISTENTE';
        },

        buscarPessoa() {
            PessoaService.buscaPessoabunge()
                .then(({ data }) => {
                    this.pessoas = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        buscarPerfilPessoa() {
            PerfilPessoaService.buscaPerfilpessoa()
                .then(({ data }) => {
                    this.gerente = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },
        getUserNameById() {
            let idPerfil = null;
            if (this.novoUsuario.perfil !== undefined) {
                idPerfil = this.novoUsuario.perfil;
            } else {
                idPerfil = this.editarUsuario.idPerfil;
            }
            if (idPerfil >= 1) {
                this.limparPessoa();
                UsuarioService.getUserByRole(idPerfil)
                    .then(({ data }) => {
                        this.usuarioRole = data;
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: error
                        });
                    });
            }
        },

        remoteMethod(query) {
            setTimeout(() => {
                this.buscarEmpresasSubEmpresas(query);
            }, 500);
        },

        getFiltros(query) {
            return query || '';
        },

        buscarPerfis() {
            UsuarioService.buscarPerfis()
                .then(({ data }) => {
                    this.rolesOperacao = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        onChangeSearchInput() {
            this[
                this.activeTab === 'usuarios' ? 'getUsuarios' : 'getSucursales'
            ]();
        },

        alterarMostrarModalCadastrarUsuario() {
            this.limparModalCadastrarUsuario();
            this.mostrarModalCadastrarUsuario =
                !this.mostrarModalCadastrarUsuario;

            if (this.mostrarModalCadastrarUsuario) {
                this.buscarEmpresasSubEmpresas('');
            }
        },

        limparModalCadastrarUsuario() {
            this.editarUsuario = {
                id: '',
                nome: '',
                email: '',
                administrador: false,
                idEmpresa: '',
                idRole: '',
                idTipo: ''
            };
            this.novoUsuario = {
                nome: '',
                email: '',
                administrador: false,
                empresa: {},
                idEmpresa: '',
                idRole: ''
            };
            this.novoUsuarioGestor = {
                idPessoa: ''
            };
            this.roleSelecionada = {
                roleSelecionada: ''
            };
            this.novoUsuarioGestor = {
                idPessoa: ''
            };
            this.roleSelecionada = {
                roleSelecionada: ''
            };
        },

        limparPessoa() {
            this.editarUsuario.idPessoa = null;
        },

        limpaPefilPessoa() {
            this.editarUsuario.idPerfil = null;
            this.editarUsuario.idPessoa = null;
        },

        async cadastrarUsuario() {
            this.novoUsuario.empresa = this.empresas.find(
                e => e.id === this.novoUsuario.idEmpresa
            );
            await UsuarioService.save({
                nome: this.novoUsuario.nome,
                email: this.novoUsuario.email,
                isAdmin: this.novoUsuario.administrador,
                pathEmpresa: this.novoUsuario.empresa.path,
                idEmpresa: this.novoUsuario.empresa.id,
                idRole: this.roleSelecionada.id,
                idPessoa: this.novoUsuarioGestor.idPessoa,
                idPerfil: this.novoUsuario.perfil
            })
                .then(({ data }) => {
                    if (data === 'USUARIO_ADICIONADO_EMPRESA') {
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.usuarios.usuarioAdicionadoEmpresa'
                            )
                        });
                    } else {
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.usuarios.usuarioCadastrado'
                            )
                        });
                    }

                    this.alterarMostrarModalCadastrarUsuario();
                    setTimeout(() => {
                        this.getUsuarios();
                    }, 1000);
                })
                .catch(error => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.usuarios.erroCadastrarUsuario') +
                            `: ${error.response.data.message}`
                    });
                });
        },
        abrirModalEditarUsuario({
            id,
            name,
            email,
            isAdmin,
            isSubGroup,
            group,
            idGroup,
            role,
            idPerfil,
            idPessoa
        }) {
            this.editarUsuario = {
                id,
                nome: name,
                email,
                administrador: isAdmin,
                idEmpresa: idGroup,
                idRole: role,
                idPerfil: idPerfil,
                idPessoa: idPessoa
            };
            var roleFiltrada = this.rolesOperacao.filter(roleOperacao => {
                return (
                    (isAdmin && roleOperacao.description === 'Administrador') ||
                    (!isAdmin && roleOperacao.name === role?.name)
                );
            });
            this.roleSelecionada =
                roleFiltrada !== null && roleFiltrada.length !== 0
                    ? roleFiltrada[0]
                    : '';
            this.buscarEmpresasSubEmpresas('');

            this.mostrarModalEditarUsuario = true;
        },

        fecharModalEditarUsuario() {
            this.mostrarModalEditarUsuario = false;
        },

        enviarUsuarioEditado() {
            const empresaSelecionada = this.empresas.find(
                e => e.id === this.editarUsuario.idEmpresa
            );
            this.editarUsuario.empresa = empresaSelecionada;
            const idPerfil = this.editarUsuario.idPerfil;
            const idPessoa = this.editarUsuario.idPessoa || null;
            UsuarioService.edit(
                {
                    nome: this.editarUsuario.nome,
                    email: this.editarUsuario.email,
                    isAdmin: this.editarUsuario.administrador,
                    pathEmpresa: this.editarUsuario.empresa.path,
                    idEmpresa: this.editarUsuario.empresa.id,
                    idRole: this.roleSelecionada.id,
                    idPerfil: idPerfil,
                    idPessoa: idPessoa
                },
                this.editarUsuario.id
            )
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.usuarios.usuarioEditado')
                    });
                    this.fecharModalEditarUsuario();
                    setTimeout(() => {
                        this.getUsuarios();
                    }, 1000);
                })
                .catch(error => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.usuarios.erroEditarUsuario') +
                            `: ${error.response.data.message}`
                    });
                });
        },

        acaoAlterarStatus({ id, enabled, firstName, lastName, idGroup }) {
            this.alterarStatusUsuario = {
                nome: `${firstName} ${lastName}`,
                status: enabled,
                id,
                idGroup
            };
            this.alterarModalAlterarStatus();
        },

        alterarModalAlterarStatus() {
            this.mostrarModalAlterarStatus = !this.mostrarModalAlterarStatus;
        },

        alterarStatus() {
            if (this.usuarioLogado.ambienteLogado === 'BR') {
                UsuarioService.changeEnabledBR(
                    this.alterarStatusUsuario.id,
                    !this.alterarStatusUsuario.status
                )
                    .then(() => {
                        this.$notify.success({
                            message: this.alterarStatusUsuario.status
                                ? this.$t(
                                    'mensagens.usuarios.usuarioInativadoSucesso'
                                )
                                : this.$t(
                                    'mensagens.usuarios.usuarioAtivadoSucesso'
                                )
                        });
                        this.alterarModalAlterarStatus();
                        setTimeout(() => {
                            this.getUsuarios();
                        }, 1000);
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: error.response?.data?.message
                        });
                    });
            } else {
                UsuarioService.changeEnabled(
                    this.alterarStatusUsuario.id,
                    !this.alterarStatusUsuario.status,
                    this.alterarStatusUsuario.idGroup
                )
                    .then(() => {
                        this.$notify.success({
                            message: this.alterarStatusUsuario.status
                                ? this.$t(
                                    'mensagens.usuarios.usuarioInativadoSucesso'
                                )
                                : this.$t(
                                    'mensagens.usuarios.usuarioAtivadoSucesso'
                                )
                        });
                        this.alterarModalAlterarStatus();
                        setTimeout(() => {
                            this.getUsuarios();
                        }, 1000);
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: error.response?.data?.message
                        });
                    });
            }
        },

        reenviarEmail({ id, email }) {
            UsuarioService.sendEmail(id)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.usuarios.emailEnviado')
                    });
                })
                .catch(erro => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.usuarios.erroEnvioEmail') +
                            `: ${erro.response.message}`
                    });
                });
        },

        ordenar({ order }) {
            if (order === null) {
                this.ordem = null;
                return;
            }

            this.ordem = order === 'ascending' ? 'ASC' : 'DESC';
            this.getUsuarios();
        },

        getRoleTraduzido(role) {
            if (role != null) {
                switch (role) {
                    case 'Gestor':
                        return this.$t('mensagens.usuarios.perfil.gestor');
                    case 'Regular':
                        return this.$t('mensagens.usuarios.perfil.regular');
                    case 'Administrador':
                        return this.$t(
                            'mensagens.usuarios.perfil.administrador'
                        );
                    case 'Assistente':
                        return this.$t('mensagens.usuarios.perfil.assistente');
                    default:
                        return role;
                }
            }

            return '';
        }
    }
};
</script>

<style lang="scss">
#usuarios {
    header .acoes {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .usuarios__barra-pesquisa {
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        background-color: var(--white);
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        i.el-icon-search {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-usuarios__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .pagination {
        background-color: var(--white);
        border-radius: 0 0 2px 2px;
        justify-content: center;
    }

    .tabela {
        border-radius: 5px;
        overflow: hidden;
        background-color: var(--white);
        height: calc(100vh - 258px);
        width: 100%;
        padding-top: 0 !important;
        padding-bottom: 0 !important;

        .acoes:hover {
            cursor: pointer;
        }
    }

    .nome {
        em {
            font-size: 12px;
            background-color: #d1ead2;
            border: 1px solid #bae0bc;
            border-radius: 4px;
            padding: 0 4px;
            margin-left: 8px;
        }
    }

    .verificado,
    .nao-verificado,
    .ativo,
    .inativo {
        border-radius: 20px;
        text-align: center;
        max-width: 120px;
        color: var(--black);
    }

    .verificado,
    .ativo {
        background-color: #d1ead2;
        border: 1px solid #bae0bc;
    }

    .nao-verificado,
    .inativo {
        background-color: #ffaeae;
        border: 1px solid var(--danger);
    }

    .modal-cadastrar-usuario,
    .modal-editar-usuario,
    .modal-altera-status {
        footer {
            display: flex;
            justify-content: space-between;

            .el-button {
                width: 80px;
            }
        }

        .label {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        .label-line {
            display: block;
        }

        .erroInput {
            border-radius: 4px;
            border: 1px solid red;
        }

        .erro {
            color: red;
            font-size: 10px;
            display: block;
            line-height: 1.5;
        }

        .el-form-item__label {
            margin-bottom: -10px;
        }
    }
    .el-select {
        width: 460px;
    }
}
</style>
